import { render, staticRenderFns } from "./ReportingPage.vue?vue&type=template&id=23cbaae5&scoped=true&"
import script from "./ReportingPage.vue?vue&type=script&lang=js&"
export * from "./ReportingPage.vue?vue&type=script&lang=js&"
import style0 from "./ReportingPage.vue?vue&type=style&index=0&id=23cbaae5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cbaae5",
  null
  
)

export default component.exports